import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/firebaseConfig";

const UpgradeEducator = () => {
  const navigate = useNavigate();
  const [loadingPlan, setLoadingPlan] = useState(null);

  const startCheckout = async (planKey) => {
    setLoadingPlan(planKey);
    try {
      const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
      const { data } = await createCheckoutSession({
        planKey,
        successUrl: `${window.location.origin}/upgrade-success`,
        cancelUrl: `${window.location.origin}/upgrade-educator`,
      });
      window.location.href = data.url;
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Something went wrong starting checkout. Please try again.");
      setLoadingPlan(null);
    }
  };
  
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Your Trial Has Ended</h1>

        <p style={styles.subtitle}>
          To continue accessing educator tools and student classrooms,
          please upgrade your account.
        </p>

        <div style={styles.features}>
          <h3>What you get after upgrading:</h3>
          <ul>
            <li>✅ Unlimited access to all subjects</li>
            <li>✅ Classroom & student progress tracking</li>
            <li>✅ Include students access with the po option</li>
            <li>✅ Priority educator support</li>
          </ul>
        </div>

        <div style={styles.priceBox}>
          <strong>$15 / month</strong>
          <span style={{ fontSize: 14 }}>(Educator plan)</span>
        </div>

        <div style={styles.buttons}>
          <button
            style={styles.primaryBtn}
            disabled={loadingPlan !== null}
            onClick={() => startCheckout("educator_monthly")}
          >
            {loadingPlan === "educator_monthly" ? "Redirecting…" : "Upgrade Monthly – $15"}
          </button>

<button
  style={{ ...styles.primaryBtn, background: "#16a34a" }}
  disabled={loadingPlan !== null}
  onClick={() => startCheckout("educator_yearly")}
>
  {loadingPlan === "educator_yearly" ? "Redirecting…" : "Upgrade Yearly – Save $30"}
</button>

<button
  style={styles.secondaryBtn}
  onClick={() => navigate("/purchase-order")}
>
  Request School Purchase Order
</button>

          <button
            style={styles.secondaryBtn}
            onClick={() => navigate("/educator/dashboard")}
          >
            Back to Dashboard
          </button>
        </div>

        <p style={styles.note}>
          Schools may use purchase orders.
          <br />
          Questions? Email support@smartboardlearning.com
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  card: {
    background: "#fff",
    maxWidth: 520,
    width: "100%",
    borderRadius: 12,
    padding: 28,
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    textAlign: "center",
  },
  title: {
    marginBottom: 10,
    fontSize: 28,
    color: "#111",
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 20,
    color: "#444",
  },
  features: {
    textAlign: "left",
    marginBottom: 20,
  },
  priceBox: {
    background: "#eef4ff",
    border: "2px solid #0a6cff",
    borderRadius: 8,
    padding: 12,
    marginBottom: 20,
    fontSize: 20,
    fontWeight: 700,
  },
  buttons: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    marginBottom: 16,
  },
  primaryBtn: {
    background: "#0a6cff",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
  },
  secondaryBtn: {
    background: "#e5e7eb",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
  },
  note: {
    fontSize: 13,
    color: "#555",
    marginTop: 10,
  },
};

export default UpgradeEducator;
